export default __webpack_public_path__ + "static/room-hero-2a6c185097cf6cf97512a70981c4fa9e.jpg";